export default (settings: any) => settings['tooltips'] * (1 / 60) * 10
